import './vendor/userback';
import './vendor/flowtype';
import './vendor/fitvids';
import 'electro-privacy';
import 'jquery-stalker';
import 'jquery-lazy'; // at least clean-your-way
import 'slick-carousel';
import 'bootstrap/js/dist/collapse';
import 'parsleyjs';

import './components/in-page-anchor-links';
import './components/init-menus';
import './components/init-sliders';
import Share from './components/share';
import Quiz from './components/quiz';

import QuantitySelector from './components/quantity-selector';
import CheckoutPage from './pages/checkout';
import ConfirmationPage from './pages/confirmation';
import VashtiePage from './pages/vashtie';
import LoginRegister from './pages/login-register';
import HowToLanding from './pages/howto-landing';
import RecallPage from './pages/recall';
import Testimonials from './components/testimonials';

// WASP features
import ProductSingle from './pages/product-single';
//import ScentQuiz from './components/scent-quiz';

if (window.location.pathname === '/cart/') {
    new QuantitySelector();
} else if (window.location.pathname === '/checkout/') {
    new CheckoutPage();
} else if (window.location.pathname.indexOf('order-received') !== -1) {
    new ConfirmationPage();
} else if (window.location.pathname === '/pine-sol-exclusive/') {
    new VashtiePage();
} else if (window.location.pathname.indexOf('login') !== -1 || window.location.pathname.indexOf('register') !== -1) {
    new LoginRegister();
} else if (window.location.pathname === '/recall/') {
    new RecallPage();
}

// port page code from legacy js
(async () => {
    const { pathname } = window.location;
    const { classList } = document.body;

    if (pathname === '/cleaning-surfaces/') {
        await import(
            /* webpackChunkName: "archive-ps_howtos" */
            './pages/archive-ps_howtos'
        );

        const howToLanding = new HowToLanding();
        howToLanding.init();
    } else if (classList.contains('single-ps_howtos')) {
        await import(
            /* webpackChunkName: "single-howto" */
            './pages/single-howto'
        );

        const share = new Share();
        share.init();
    } else if (pathname === '/clean-your-way/') {
        await import(
            /* webpackChunkName: "clean-your-way" */
            './pages/clean-your-way'
        );
    } else if (pathname === '/faq/' || pathname === '/history/' ) {
        await import(
            /* webpackChunkName: "faq" */
            './pages/faq'
        );
    } else if (classList.contains('single-ps_products')) {
        await import(
            /* webpackChunkName: "product-single" */
            './pages/product-single'
        );
        new ProductSingle();
    }
})();

if (document.querySelector('.js-search-results-grid')) {
    const { default: Search } = await import(
        /* webpackChunkName: "search" */
        './pages/search'
    );
    /* eslint-disable no-unused-vars */
    const search = new Search();
    search.init();
}

if (document.querySelector('.module-review')) {
    const { default: ModuleReview } = await import(
        /* webpackChunkName: "module-review" */
        './components/module-review'
    );
    /* eslint-disable no-unused-vars */
    const moduleReview = new ModuleReview();
}

if (document.querySelector('.panel--scent-quiz')) {
    const quiz = new Quiz();
    quiz.init();
}

if (document.querySelector('section.testimonials ')) {
    const testimonials = new Testimonials();
}


function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    if (match) return match[2];
    return null;
}

let videoIntervialAttempts = 0;
const videoModuleInterval = setInterval(() => {
    const OptanonCookies = getCookie('OptanonConsent');

    if (OptanonCookies) {
        clearInterval(videoModuleInterval);
        const interactions = OptanonCookies ? !OptanonCookies.includes('interactionCount=0') : true;
        Electro.targetingCookies = OptanonCookies ? OptanonCookies.includes('C0004%3A1') : false;

        if (!interactions || Electro.targetingCookies) {
            initVideoModules();
        } else {
            displayVideoConsentMessage();
        }
    } else if (videoIntervialAttempts > 50) {
        clearInterval(videoModuleInterval);
        displayVideoConsentMessage();
    }

    videoIntervialAttempts += 1;
}, 100);

function initVideoModules () {
    $('.module-video .btn-default.btn-video').removeClass('.disabled');
    $('.module-video .btn-default.btn-video, .js-youtube-trigger').on('click', function (e) {
        e.preventDefault();
        // console.log('click video');
        const $module = $(this).closest('.module-video');
        const $iframe = $('iframe', $module);
        let src = $iframe.attr('src');
        src += src.indexOf('?') !== -1 ? '&autoplay=1' : '?autoplay=1';
        $iframe.attr('src', src);

        setTimeout(() => {
            $module.find('.video-image__yt-overlay').fadeOut();
        }, 500);

        return false;
    });


    $('.js-image-over-video').on('click', function () {
        const $this = $(this);
        const $player = $this.closest('.video-frame').find('.video-feature');
        const $iframe = $player.find('iframe');
        const vidid = $iframe.data('video-id');
        const playlist = $(`.${$this.data('playlist')}`);

        if (playlist === 'true') {
            $iframe.attr(
                'src',
                `//www.youtube.com/embed/videoseries?list=${vidid}&enablejsapi=1&autoplay=1&rel=0`
            );
        } else {
            // add youtube url w/autoplay to iframe
            $iframe.attr('src', `//www.youtube.com/embed/${vidid}?enablejsapi=1&autoplay=1&rel=0`);
        }
        $player.show();

        // hide image
        $this.hide();

        return false;
    });
    // Add keyboard accessibility
    // use `tabindex="0"` in markup to allow keyboard focus
    $('.js-image-over-video').on('keypress', function (e) {
        if (e.which === 13) {
            $(this).trigger('click');
        }
    });

}

function displayVideoConsentMessage() {
    if (document.querySelector('.module-video')) {
        $('.module-video').find('.consent-message').removeClass('hidden');
        $('.module-video').find('button').addClass('disabled');
        $('.module-video').find('iframe').remove();
    }

    if (document.querySelector('.js-image-over-video')) {
        document.querySelectorAll('.js-image-over-video').forEach((el) => {
            const container = el.closest('.video-frame');
            const player = container.querySelector('.video-feature');
            const consentMessage = container.querySelector('.consent-message')
            consentMessage.classList.remove('hidden');
            el.classList.add('disabled');
            player.remove();
        });
    }
}

// site.common.js (legacy)
// //////////////////////////////////////////////////////////////////////////////
// Bind primary nav to keyboard buttons for a11y
// //////////////////////////////////////////////////////////////////////////////
$(document).ready(() => {
    // open social media links in new windows
    window.socialWindow = function (url) {
        const left = (window.screen.width - 570) / 2;
        const top = (window.screen.height - 570) / 2;
        const params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`;
        window.open(url, 'NewWindow', params);
    };

    // Setup the a11y nav
    $('#menu-primary-nav').setup_navigation();
    $('#menu-primary-nav-spanish').setup_navigation();
    $('#menu-primary-nav-wasp').setup_navigation();

    // SITE-SPECIFIC
    // //////////////////////////////////////////////////////////////////////////
    // Set certain behaviors once device is set, including hide/show content
    // based on device
    // //////////////////////////////////////////////////////////////////////////

    const isDevice = () => {
        let mobile = JSON.parse(localStorage.getItem('isMobile'));
        if (mobile === null) {
            const ua = navigator.userAgent;

            mobile =
                ua.length > 0 &&
                (ua.indexOf('Mobile') !== -1 ||
                    ua.indexOf('Android') !== -1 ||
                    ua.indexOf('Silk/') !== -1 ||
                    ua.indexOf('Kindle') !== -1 ||
                    ua.indexOf('BlackBerry') !== -1 ||
                    ua.indexOf('Opera Mini') !== -1 ||
                    ua.indexOf('Opera Mobi') !== -1);

            localStorage.setItem('isMobile', JSON.stringify(mobile));
        }

        return mobile;
    };

    window.PS_GLOBAL = {
        isDevice: isDevice(),
    };

    if (PS_GLOBAL.isDevice) {
        $('.ps-device-only').removeClass('hidden');
    } else {
        $('.ps-desktop-only').removeClass('hidden');
    }

    // SITE-SPECIFIC
    // //////////////////////////////////////////////////////////////////////////
    // keep youtube videos from going above the primary nav
    // https://stackoverflow.com/questions/9074365/youtube-video-embedded-via-iframe-ignoring-z-index
    // //////////////////////////////////////////////////////////////////////////

    $('iframe').each(function () {
        const url = $(this).attr('src');
        if (!url) return;
        if ($(this).attr('src').indexOf('?') > 0) {
            $(this).attr({
                src: `${url}&wmode=transparent`,
                wmode: 'Opaque',
            });
        } else {
            $(this).attr({
                src: `${url}?wmode=transparent`,
                wmode: 'Opaque',
            });
        }
    });

    // SITE-SPECIFIC
    // //////////////////////////////////////////////////////////////////////////
    // Make an entire div clickable by adding this class
    // //////////////////////////////////////////////////////////////////////////
    $('.make-link').click(function () {
        window.location = $(this).find('a').attr('href');
        return false;
    });

    // satellite js file creates a script tag with id="undefined"
    //  wordpress parseAjaxResponse has bug when this exists
    //    and tries to use it, which isn't allowed on IE8
    $('#undefined').attr('id', '');

    // add handlers for switch buttons for full page forms
    $(document).on('click', '.btn-switch-login,.btn-switch-signup', function (e) {
        const url = $(this).attr('href');
        window.location = url;
    });

    // RWD Nav Pattern
    $('body').addClass('js');
    const $menu = $('#menu');
    const $menulink = $('.menu-link');
    const $menuTrigger = $('.has-subnav > a');

    $menulink.click((e) => {
        e.preventDefault();
        $menulink.toggleClass('active');
        $menu.toggleClass('active');
    });

    $menuTrigger.click(function (e) {
        e.preventDefault();
        const $this = $(this);
        $this.toggleClass('active').next('.dropdown-menu').toggleClass('active');
    });

    // //////////////////////////////////////////////////////////////////////////
    // Make header sticky in desktop resolution
    // //////////////////////////////////////////////////////////////////////////
    $('.nav-primary').stalker({
        stalkerStyle: 'fixed-nav',
    });
});

const keyCodeMap = {
    48: '0',
    49: '1',
    50: '2',
    51: '3',
    52: '4',
    53: '5',
    54: '6',
    55: '7',
    56: '8',
    57: '9',
    59: ';',
    65: 'a',
    66: 'b',
    67: 'c',
    68: 'd',
    69: 'e',
    70: 'f',
    71: 'g',
    72: 'h',
    73: 'i',
    74: 'j',
    75: 'k',
    76: 'l',
    77: 'm',
    78: 'n',
    79: 'o',
    80: 'p',
    81: 'q',
    82: 'r',
    83: 's',
    84: 't',
    85: 'u',
    86: 'v',
    87: 'w',
    88: 'x',
    89: 'y',
    90: 'z',
    96: '0',
    97: '1',
    98: '2',
    99: '3',
    100: '4',
    101: '5',
    102: '6',
    103: '7',
    104: '8',
    105: '9',
};

$.fn.setup_navigation = function (settingsIn) {
    const settings = jQuery.extend(
        {
            menuHoverClass: 'show-menu',
            mouseleaveHideDuration: 1000,
        },
        settingsIn
    );

    // Add ARIA role to menubar and menu items
    $(this).attr('role', 'menubar').find('li').attr('role', 'menuitem');

    const topLevelLinks = $(this).find('> li > a');
    // this is set here to make it easy to cancel the setTimeout if the user mouses back in
    let mouseleaveTimer;

    // Added by Terrill: (removed temporarily: doesn't fix the JAWS problem after all)
    // Add tabindex="0" to all top-level links
    // Without at least one of these, JAWS doesn't read widget as a menu, despite all the other ARIA
    // $(topLevelLinks).attr('tabindex','0');

    // Set tabIndex to -1 so that topLevelLinks can't receive focus until menu is open
    $(topLevelLinks)
        .next('.dropdown-menu')
        .attr('data-test', 'true')
        .attr({ 'aria-hidden': 'true', role: 'menu' })
        .find('a')
        .attr('tabIndex', -1);

    // Adding aria-haspopup for appropriate items
    $(topLevelLinks).each(function () {
        if ($(this).next('.dropdown-menu').length > 0) {
            $(this).parent('li').attr('aria-haspopup', 'true');
        }
    });

    $(topLevelLinks).hover(function () {
        // cancel any setTimeout that may be preparing to hide the menu due to mouseleave function
        clearTimeout(mouseleaveTimer);
        $(this)
            .closest('ul')
            .attr('aria-hidden', 'false')
            .find(`.${settings.menuHoverClass}`)
            .attr('aria-hidden', 'true')
            .removeClass(settings.menuHoverClass)
            .find('a')
            .attr('tabIndex', -1);
        $(this).next('.dropdown-menu').attr('aria-hidden', 'false').addClass(settings.menuHoverClass).find('a').attr('tabIndex', 0);
    });

    $(topLevelLinks)
        .parent('li')
        .mouseleave(() => {
            mouseleaveTimer = setTimeout(() => {
                $(`.${settings.menuHoverClass}`)
                    .attr('aria-hidden', 'true')
                    .removeClass(settings.menuHoverClass)
                    .find('a')
                    .attr('tabIndex', -1);
            }, settings.mouseleaveHideDuration);
        });

    $(topLevelLinks).focus(function () {
        $(this)
            .closest('ul')
            .find(`.${settings.menuHoverClass}`)
            .attr('aria-hidden', 'true')
            .removeClass(settings.menuHoverClass)
            .find('a')
            .attr('tabIndex', -1);

        $(this).next('.dropdown-menu').attr('aria-hidden', 'false').addClass(settings.menuHoverClass).find('a').attr('tabIndex', 0);
    });

    // Bind arrow keys for navigation
    $(topLevelLinks).keydown(function (e) {
        if (e.keyCode === 37) {
            e.preventDefault();
            // This is the first item
            if ($(this).parent('li').prev('li').length === 0) {
                $(this).parents('.dropdown-menu').find('> li').last().find('a').first().focus();
            } else {
                $(this).parent('li').prev('li').find('a').first().focus();
            }
        } else if (e.keyCode === 38) {
            e.preventDefault();
            if ($(this).parent('li').find('.dropdown-menu').length > 0) {
                $(this)
                    .parent('li')
                    .find('.dropdown-menu')
                    .attr('aria-hidden', 'false')
                    .addClass(settings.menuHoverClass)
                    .find('a')
                    .attr('tabIndex', 0)
                    .last()
                    .focus();
            }
        } else if (e.keyCode === 39) {
            e.preventDefault();
            // This is the last item
            if ($(this).parent('li').next('li').length === 0) {
                $(this).parents('.dropdown-menu').find('> li').first().find('a').first().focus();
            } else {
                $(this).parent('li').next('li').find('a').first().focus();
            }
        } else if (e.keyCode === 40) {
            e.preventDefault();
            if ($(this).parent('li').find('.dropdown-menu').length > 0) {
                $(this)
                    .parent('li')
                    .find('.dropdown-menu')
                    .attr('aria-hidden', 'false')
                    .addClass(settings.menuHoverClass)
                    .find('a')
                    .attr('tabIndex', 0)
                    .first()
                    .focus();
            }
        } else if (e.keyCode === 13 || e.keyCode === 32) {
            // If submenu is hidden, open it
            e.preventDefault();
            $(this)
                .parent('li')
                .find('.dropdown-menu[aria-hidden=true]')
                .attr('aria-hidden', 'false')
                .addClass(settings.menuHoverClass)
                .find('a')
                .attr('tabIndex', 0)
                .first()
                .focus();
        } else if (e.keyCode === 27) {
            e.preventDefault();
            $(`.${settings.menuHoverClass}`)
                .attr('aria-hidden', 'true')
                .removeClass(settings.menuHoverClass)
                .find('a')
                .attr('tabIndex', -1);
        } else {
            $(this)
                .parent('li')
                .find('.dropdown-menu[aria-hidden=false] a')
                .each(function () {
                    if ($(this).text().substring(0, 1).toLowerCase() === keyCodeMap[e.keyCode]) {
                        $(this).focus();
                        return false;
                    }
                    return undefined;
                });
        }
    });

    const links = $(topLevelLinks).parent('li').find('.dropdown-menu').find('a');
    $(links).keydown(function (e) {
        if (e.keyCode === 38) {
            e.preventDefault();
            // This is the first item
            if ($(this).parent('li').prev('li').length === 0) {
                $(this).parents('.dropdown-menu').parents('li').find('a').first().focus();
            } else {
                $(this).parent('li').prev('li').find('a').first().focus();
            }
        } else if (e.keyCode === 40) {
            e.preventDefault();
            if ($(this).parent('li').next('li').length === 0) {
                $(this).parents('.dropdown-menu').parents('li').find('a').first().focus();
            } else {
                $(this).parent('li').next('li').find('a').first().focus();
            }
        } else if (e.keyCode === 27 || e.keyCode === 37) {
            e.preventDefault();
            $(this)
                .parents('.dropdown-menu')
                .first()
                .prev('a')
                .focus()
                .parents('.dropdown-menu')
                .first()
                .find(`.${settings.menuHoverClass}`)
                .attr('aria-hidden', 'true')
                .removeClass(settings.menuHoverClass)
                .find('a')
                .attr('tabIndex', -1);
        } else if (e.keyCode === 32) {
            e.preventDefault();
            window.location = $(this).attr('href');
        } else {
            let found = false;
            $(this)
                .parent('li')
                .nextAll('li')
                .find('a')
                .each(function () {
                    if ($(this).text().substring(0, 1).toLowerCase() === keyCodeMap[e.keyCode]) {
                        $(this).focus();
                        found = true;
                        return false;
                    }
                    return undefined;
                });

            if (!found) {
                $(this)
                    .parent('li')
                    .prevAll('li')
                    .find('a')
                    .each(function () {
                        if ($(this).text().substring(0, 1).toLowerCase() === keyCodeMap[e.keyCode]) {
                            $(this).focus();
                            return false;
                        }
                        return undefined;
                    });
            }
        }
    });

    // Hide menu if click or focus occurs outside of navigation
    $(this)
        .find('a')
        .last()
        .keydown((e) => {
            if (e.keyCode === 9) {
                // If the user tabs out of the navigation hide all menus
                $(`.${settings.menuHoverClass}`)
                    .attr('aria-hidden', 'true')
                    .removeClass(settings.menuHoverClass)
                    .find('a')
                    .attr('tabIndex', -1);
            }
        });

    $(document).click(() => {
        $(`.${settings.menuHoverClass}`)
            .attr('aria-hidden', 'true')
            .removeClass(settings.menuHoverClass)
            .find('a')
            .attr('tabIndex', -1);
    });

    $(this).click((e) => {
        e.stopPropagation();
    });

    $('.menu-toggle').hover((e) => {
        const $this = $(e.currentTarget);
        const $target = $( $this.attr('data-target') );
        $this.closest('ul').find('.menu-toggle').removeClass('active');
        $this.addClass('active');
        $target.closest('.dropdown-menu').find('.nav-sub').addClass('hidden');
        $target.removeClass('hidden');
    });

    $('.menu-toggle').focus((e) => {
        const $this = $(e.currentTarget);
        $this.trigger('mouseover');

    });

    $('.menu-toggle').keydown((e) => {
        if (e.keyCode === 39) {
            const $this = $(e.currentTarget);
            const $target = $( $this.attr('data-target') );
            $target.find('a').first().focus();
        }
    });

    $('.menu-container [aria-haspopup="true"] > a').on('click', (e) => {
        if (window.innerWidth < 1025) {
            e.preventDefault();
            const el = $(e.currentTarget);
            if( el.closest('li').find('.show-menu').length > 0 ) {
                el.closest('li').find('.show-menu').removeClass('show-menu');
            } else {
                el.closest('li').find('.dropdown-menu').addClass('show-menu');
            }
        }
    });

    // Activate search input
    $('.header-search-form .icon-search').unbind().click((e) => {
        e.preventDefault();
        const form = $(e.currentTarget).closest('form');
        if (form.hasClass('open')) {
            form.submit();
        } else {
            form.addClass('open');
        }
    });

    // user clicks outside of search form
    $(document).click((e) => {
        if (!$(e.target).closest('.header-search-form').length) {
            $('.header-search-form').removeClass('open');
        }
        if (!$(e.target).closest('.header-search-form').length) {
            $('.header-search-form').removeClass('open');
        }
    });

};

function mobileNav() {
    const body = $('body');
    const $mobileNavTrigger = $('#mobile-nav-trigger');
    const $mobileNav = $('#menu-container');

    $mobileNavTrigger.on('click', (e) => {
        e.preventDefault();
        body.toggleClass('open');
        $mobileNavTrigger.toggleClass('open');
        $mobileNav.toggleClass('open');
    });
}

/** *****************************************************************************
 /* document ready
 /***************************************************************************** */
jQuery(document).ready(() => {
    mobileNav();

    // OneTrust
    document.getElementById('do-not-share').addEventListener('click', () => {
        if(typeof OneTrust !== 'undefined') {
            OneTrust.ToggleInfoDisplay();
        }
    });
});

// generic-video.js (legacy)
/// /////////////////////////////////////////////////////////////////////////
// initiate fitvids for video resizing
/// /////////////////////////////////////////////////////////////////////////

$('.module-twocol').fitVids();
